export const JiraServiceManagementMarkNeutral = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.0129 19.8403L37.7859 19.9063C39.1659 19.9153 39.9479 21.4913 39.1199 22.5953L23.2209 43.8013C18.2229 40.0663 17.1989 32.9863 20.9339 27.9883L27.0139 19.8403H27.0129Z"
      fill="url(#paint0_linear_818_528)"
    />
    <path
      d="M20.925 27.9872L10.214 27.9212C8.83499 27.9132 8.05299 26.3392 8.87799 25.2352L24.625 4.19922C29.623 7.93422 30.647 15.0142 26.912 20.0122L20.924 27.9862L20.925 27.9872Z"
      fill="#758195"
    />
    <defs>
      <linearGradient
        id="paint0_linear_818_528"
        x1="26.586"
        y1="21.431"
        x2="31.1147"
        y2="35.1232"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2C3E5D" />
        <stop offset="1" stopColor="#758195" />
      </linearGradient>
    </defs>
  </svg>
);
